import React from 'react';
import { connect } from 'react-redux';

import { _getOrderData } from '../services';

import { setActiveOrder } from '../components/orders/actions';

class FocusOrderPage extends React.Component{
	render(){
		const { user } = this.props;

		if(user.loading){
			return <div key="fetch-admin-details" >Fetching admin details...</div>
		}

		return null;
	
	}

	constructor( props ){
		super(props);

		if( props.match.params.orderId ){
			_getOrderData( props.match.params.orderId )
				.then( res => this.props.setActiveOrder(res.data.order) )
		}

	}
}

export default connect(
	state => ({
		user: state.user,
		activeOrder: state.activeOrder
	}),
	dispatchEvent => ({
		setActiveOrder: ( order ) => dispatchEvent( setActiveOrder(order) )
	})
)(FocusOrderPage);


// WEBPACK FOOTER //
// ./src/containers/focus-order-page.js